import React from 'react';
import { Link } from 'react-router-dom';

import { useTranslations } from '@core/js/hooks/i18n';

import { useDynamicTags } from '@interlayer/js/custom/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/custom/utils/constants';
import { clsx } from '@interlayer/js/utils/classNames.util';

import style from '../FloatingButtons.scss';

export const SaferGambling: React.FC = () => {
    const translate = useTranslations('playtech.mobile.system.floating-button.');

    const [saferGamblingShieldURL] = useDynamicTags([DYNAMIC_TAG_NAMES.SAFER_GAMBLING_SHIELD_URL]);

    if (!saferGamblingShieldURL) {
        return null;
    }

    return (
        <Link
            to={saferGamblingShieldURL}
            className={clsx(style.item, style.isSaferGambling)}
        >
            <div className={style.icon} />

            <div className={style.title}>{translate('shield')}</div>
        </Link>
    );
};
